module.exports = __webpack_public_path__ + "img/L-S-formula.e4d34996.png";